export interface WicketAdminEntitlement {
  uid: string;
  subjects: string[];
  effect: 'allow';
  actions: WicketAdminEntitlmentAction[];
  resources: string[];
  context: {
    valid_until: {
      operator: WicketAdminEntitlementContextOperator;
      value: number;
    };
  };
  description: string;
}

export interface WicketAdminCreateEntitlement {
  invoice_id: string;
  user_id: string;
  resources: string[];
  valid_until: Date;
}

export interface WicketAdminEntitlementResource {
  id: string;
  resources: string;
  description: string;
  name: string;
}

export interface WicketAdminPlatformEntitlement {
  uid: string;
  description: string;
  platformName: string;
  endingDate: string;
  status: 'Active' | 'Expired' | 'Unknown';
}

export enum WicketAdminEntitlmentAction {
  readGet = '<read|get>',
}

export enum WicketAdminEntitlementContextOperator {
  lessOrEqual = 'LessOrEqual',
}
